import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { WhenVisibilityIsImminent } from "@faire/web--source/ui/VisibilitySensor/WhenVisibilityIsImminent";
import * as React from "react";
import styled from "styled-components";

import { RetailerFooter } from "@faire/retailer/components/Footer/RetailerFooter";
import { SDUIBannerRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/Banner/SDUIBannerRenderer";
import { SDUICarouselRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/Carousel/SDUICarouselRenderer";
import { SDUIGridRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/Grid/SDUIGridRenderer";
import { SDUIHeaderRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/Header/SDUIHeaderRenderer";
import { SDUICategoryPageLayoutElementRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/LayoutElement/SDUICategoryPageLayoutElementRenderer";
import { SDUISpacerRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/Spacer/SDUISpacerRenderer";
import { BannerLoadingSkeleton } from "@faire/retailer/components/SDUI/LoadingRenderers/Components/BannerLoadingSkeleton";
import { CarouselLoadingSkeleton } from "@faire/retailer/components/SDUI/LoadingRenderers/Components/CarouselLoadingSkeleton";
import { SDUIColumnSectionRenderer } from "@faire/retailer/components/SDUI/SectionRenderers/ColumnSection/SDUIColumnSectionRenderer";
import { SDUIFilterablePaginatedSectionRenderer } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/SDUIFilterablePaginatedSectionRenderer";
import {
  ComponentRenderMap,
  SectionRenderMap,
} from "@faire/retailer/components/SDUI/types";
import { SDUICategoryPageContentsV2 } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/SDUICategoryPageContentsV2";
import { Z_INDICES } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/LoggedInCategoryPageStyles";

const hubComponentRenderers: ComponentRenderMap = {
  layout_element: {
    active: SDUICategoryPageLayoutElementRenderer,
    pending: CarouselLoadingSkeleton,
  },
  carousel_component: {
    active: SDUICarouselRenderer,
    pending: CarouselLoadingSkeleton,
  },
  banner_component: {
    active: SDUIBannerRenderer,
    pending: BannerLoadingSkeleton,
  },
  spacer_component: {
    active: SDUISpacerRenderer,
  },
  header_component: {
    active: SDUIHeaderRenderer,
  },
  grid_component: {
    active: SDUIGridRenderer,
  },
};

const hubSectionRenders: SectionRenderMap = {
  column_section: SDUIColumnSectionRenderer,
  filterable_paginated_section: SDUIFilterablePaginatedSectionRenderer,
};

export const SDUICategoryPageBase: React.FC = () => {
  return (
    <>
      <SDUICategoryPageContentsV2
        componentRenderers={hubComponentRenderers}
        sectionRenderers={hubSectionRenders}
      />

      <WhenVisibilityIsImminent
        customizePlaceholder={<RetailerFooterPlaceholder />}
      >
        <StyledRetailerFooter hideReferral />
      </WhenVisibilityIsImminent>
    </>
  );
};

const StyledRetailerFooter = styled(RetailerFooter)`
  ${responsiveMediaQueries.desktopAndAbove} {
    background-color: white;
    position: relative;
    z-index: ${Z_INDICES.footer.desktopAndAbove};
  }
`;

const RetailerFooterPlaceholder = styled.div`
  ${responsiveMediaQueries.tabletAndBelow} {
    height: 750px;
  }

  ${responsiveMediaQueries.desktopAndAbove} {
    height: 431px;
  }
`;
